var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import FingerprintJS from '@fingerprintjs/fingerprintjs';
const elLoginForm = document.querySelector('#login-form');
const elFingerprint = document.querySelector('#login-fingerprint');
const fpPromise = FingerprintJS.load();
document.addEventListener('DOMContentLoaded', () => {
    if (!elLoginForm && !elFingerprint)
        return;
    elLoginForm.addEventListener('submit', e => {
        (() => __awaiter(void 0, void 0, void 0, function* () {
            const fp = yield fpPromise;
            const result = yield fp.get();
            elFingerprint.value = result.visitorId;
            elLoginForm.submit();
        }))();
        e.preventDefault();
    });
});
